export const nullAlias = "set_this_value_as_null"

export const changeNullValueWithAlias = (obj: Record<any, any>)=>{
    const newObj = obj
   Object.keys(newObj).forEach((key)=>{
       if(newObj[key]===null){ newObj[key]=nullAlias}
   })
return newObj
}
